import api from './api';

import { DrugstoreInterface, PermissionsInterface } from '../interfaces/drugstore';
import { UserInterface } from '../interfaces/user';

export interface FetchPermissionsResponse {
  user: UserInterface;
  current_drugstore: DrugstoreInterface;
  allowed_drugstores: DrugstoreInterface[];
}

export const getPermissions = async (userId: number, token: string): Promise<PermissionsInterface> => {
  const query = [
    `token=${token}`,
    `current_drugstore_id=${userId}`,
  ].join('&');
  const { data } = await api.get(`/dispenser/permissions?${query}`);

  return data;
};
